<template>
	<SOSlotModal
		:modal-title="'Ekspor ' + context"
		:modal-id="id"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body>
			<div v-if="!isRunning && pageSetting.section.ekspor">
				<div class="p-x-20 p-y-8 d-flex align-items-center bg-yellow">
					<div>
						<img src="../../../../src/assets/icons/alert-circle-yellow.svg" alt="" class="p-r-20">
					</div>
					<div>
						<div class="f-regular f-14 f-c-black">
							Data yang akan diekspor: <b>{{ totalData }}</b>
						</div>
						<div class="f-regular f-12 f-c-midgrey">
							{{ subContext }}
						</div>
					</div>
				</div>

				<div class="p-x-20 p-y-8 w-100" v-if="useOption">
					<SOInputSelect
						:title="'Jenis data yang diekspor'"
						:selected="selectedOption"
						:placeholder="'Pilih jenis data yang diekspor'"
						:options="options"
						@option-selected="exportOptionSelected"
					/>
				</div>

				<div class="f-regular f-14 f-c-midgrey p-x-20 p-y-16">
					Hasil ekspor berupa file *.XLS (Excel).
					Proses ini membutuhkan waktu yang relatif lama, tergantung jumlah data yang diekspor.
				</div>
			</div>
			<div class="p-x-20 p-y-16 f-regular f-16 f-c-black" v-else>
				<span v-if="!pageSetting.section.ekspor">
					{{ exportDataExist }} File belum didownload. Apakah anda yakin ingin melanjutkan & menghapus file tersebut?
				</span>
				<span v-else>
					Tidak bisa melakukan ekspor data, karena ada proses ekspor yang sedang berjalan.
				</span>
			</div>
		</template>

		<template v-slot:modal-footer v-if="!isRunning">
			<div class="p-x-20 p-y-16">
				<SOButton
					v-if="!pageSetting.section.ekspor"
					:text="'Oke, mengerti'"
					:outline="true"
					:full="true"
					:loading="pageSetting.btn.ekspor.loading"
					:disable="pageSetting.btn.ekspor.disabled"
					@action="confirmToExport"
				/>
				<SOButton
					v-else
					:text="'Ekspor'"
					:outline="true"
					:full="true"
					:loading="pageSetting.btn.ekspor.loading"
					:disable="pageSetting.btn.ekspor.disabled"
					@action="doExport"
				/>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "SOModalExport",
	components: {
		SOButton,
		SOInputSelect,
		SOSlotModal,
	},
	props: {
		context: String,
    subContext: {
      type: String,
      default: "Menyesuaikan dgn filter (jika diterapkan)"
    },
		totalData: String,
		isRunning: Boolean,
		exportDataExist: Number,

		useOption: Boolean,
		options: Array,
		selectedOption: String,
	},
	mounted() {
		$("#" + this.id).modal("show");
		this.pageSetting.section.ekspor = this.exportDataExist === 0
	},
	data() {
		return {
			id: "modal-ekspor",
			pageSetting: {
				section: {
					ekspor: true
				},
				btn: {
					ekspor: {
						disabled: false,
						loading: false,
					}
				}
			}
		}
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		exportOptionSelected(selected) {
			this.$emit("export-option-selected", selected)
		},
		confirmToExport() {
			this.pageSetting.section.ekspor = true
		},
		doExport() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("do-export")
			}, 500)
		}
	}
}
</script>